import './init_jQuery'
import 'jquery-ui/dist/jquery-ui.min';
import Rails from '@rails/ujs'
Rails.start()
import * as bootstrap from 'bootstrap-latest'
window.bootstrap = bootstrap
import 'vendor/assets/components/notie/notie'
import 'vendor/assets/components/lightslider/dist/js/lightslider'
import 'cocoon/app/assets/javascripts/cocoon' //loaded from gem
import './custom'
import './bootstrap-datepicker.min'
import './bootstrap-datepicker.fr.min'
import 'selectize/dist/js/standalone/selectize.min.js'
import './contact_pro_user_form'
import Cookies from 'js-cookie';
window.Cookies = Cookies;
import 'cookies_eu/app/assets/javascripts/cookies_eu' //loaded from gem
import './jqvmap'
import './jqvmap.fr'
import './remote_script_request'
import './website_form_contact'
import './crud/jquery.dataTables.min'
import './crud/dataTables.bootstrap'
import './crud/dataTables.buttons.min'
import './crud/jszip.min'
import './crud/pdfmake.min'
import './crud/vfs_fonts'
import './crud/buttons.html5.min'
import './crud/buttons.print.min'
import './crud/dataTables.fixedHeader.min'
import './crud/dataTables.keyTable.min'
import './crud/dataTables.responsive.min'
import './crud/responsive.bootstrap.min'
import './crud/dataTables.scroller.min'
import 'vendor/assets/components/fitvids/jquery.fitvids.js'
import './no_youtube_rel_videos'
import 'slick-carousel/slick/slick.min'
import './projects/show'
import './school_managers/projects/show'
import './pro_users/pdp/projects'
import './pro_users/pdp/projects/registrations'
import './structures/kyc_form'
import './structures/fiscal_receipt_requests_table'
import './users_registrations'
import './pro_users/pdp/projects/adding_rewards.js'
import './covid'
import './bootstrap/bootstrap_tooltip_init'
import './body_dynamic_padding_bottom'
import './application_2024/redactor_custom'
import './application_2024/slick_init.js'

$(function () {
  var $selectize, base, base1;
  if ((base = String.prototype).startsWith == null) {
    base.startsWith = function (s) {
      return this.slice(0, s.length) === s;
    };
  }
  if ((base1 = String.prototype).endsWith == null) {
    base1.endsWith = function (s) {
      return s === '' || this.slice(-s.length) === s;
    };
  }
  $('.go-to-payment').on('click', function (event) {
    event.preventDefault();
    $('.go-to-payment').attr('disabled', 'disabled');
    $(this).find('p').text('Traitement en cours...');
    $(this).parents('form').submit();
    return $(this).parents('form').submit();
  });
  $('.carousel').carousel({
    interval: 5000,
  });
  $('input[type=radio]').removeClass('form-control');

  $('select[id$="_function_id"]').on('change', function () {
    if (parseInt($(this).val()) === 8) {
      $('input[id$="_function"]').parents('div.form-group').show();
    } else {
      $('input[id$="_function"]').parents('div.form-group').hide();
    }
  });
  if (parseInt($('select[id$="_function_id"]').val()) === 8) {
    $('input[id$="_function"]').parents('div.form-group').show();
  } else {
    $('input[id$="_function"]').parents('div.form-group').hide();
  }
  $('div.form-group.boolean').each(function () {
    $(this).prepend($(this).find('label:not(".control-label")').html());
    $(this).find('label:not(".control-label")').remove();
    return $(this).find('input[type="hidden"]').remove();
  });
  $('.nav-stacked a').each(function () {
    if (this.href === window.location.href) {
      $(this).parent().addClass('active');
    }
  });
  $('#video-project').fitVids();
  $('#partners-lightslider').lightSlider({
    autoWidth: true,
    slideMove: 2,
    loop: true,
    speed: 10,
  });
  $('p.help-block').each(function (el) {
    var text;
    text = $(this).text();
    return $(this)
      .parents('.form-group')
      .find('label')
      .append(
        '<button data-toggle="tooltip" class="unset-btn-appearance" title="' +
          text +
          '><i class="fa fa-question-circle"></i></button>'
      );
  });
  $('[data-toggle="tooltip"]').tooltip();
  $('.datatable#pdp-project-datatable').DataTable({
    autoWidth: false,
    pageLength: 5,
    aaSorting: [[0, 'desc']],
    language: {
      url: '//cdn.datatables.net/plug-ins/1.10.12/i18n/French.json',
    },
    dom: 'Bfrtip',
    initComplete: function (settings, json) {
      return $('.dt-buttons a.dt-button').addClass('btn btn-default btn-sm');
    },
    buttons: [
      {
        extend: 'excel',
        exportOptions: {
          columns: ':not(.action)',
        },
        className: 'btn-md btn-pink btn-rounded',
      },
      {
        extend: 'pdfHtml5',
        exportOptions: {
          columns: ':not(.action)',
        },
        className: 'btn-md btn-pink btn-rounded',
        orientation: 'landscape',
        pageSize: 'A1',
        customize: function (doc) {
          var colCount;
          colCount = new Array();
          $('.datatable')
            .find('tbody tr:first-child td')
            .each(function () {
              var i;
              if ($(this).attr('colspan')) {
                i = 1;
                while (i <= $(this).attr('colspan')) {
                  colCount.push('*');
                  i++;
                }
              } else {
                colCount.push('*');
              }
            });
          doc.content[1].table.widths = colCount;
        },
      },
      {
        extend: 'print',
        exportOptions: {
          columns: ':visible:not(.action)',
        },
        className: 'btn-md btn-pink btn-rounded',
        text: 'Imprimer',
      },
      {
        text: 'Écrire à tous',
        action: function (e, dt, button, config) {
          window.location = $('#pdp-project-datatable').data(
            'bulk_message_url'
          );
        },
      },
    ],
  });
  if ($('#map').length) {
    $('#map').vectorMap({
      map: 'france_fr',
      backgroundColor: 'transparent',
      borderColor: '#000000',
      selectedColor: '#1f71b9',
      hoverColor: '#1f71b9',
      hoverOpacity: null,
      enableZoom: false,
      showTooltip: true,
      onRegionClick: function (element, code, region) {
        window.location = encodeURI(
          '/projet?q[school_city_department_code_start]=' + code
        );
      },
    });
  }
  $('select[multiple]').selectize();
  $('.selectize-control, .selectize-dropdown').removeClass('form-control');
  $selectize = $('select[id$=school_id]').selectize();
  if ($selectize.length) {
    $selectize = $selectize[0].selectize;
  }
  $('select[id=zip_code_search]').selectize({
    valueField: 'zip_code',
    labelField: 'zip_code',
    searchField: ['zip_code'],
    options: [],
    create: false,
    selectOnTab: true,
    onChange: function (value) {
      if (!value) {
        return;
      }
      return $.ajax({
        url: '/schools.json',
        type: 'GET',
        data: {
          c: value,
        },
        error: function () {
          console.log('error');
        },
        success: function (res) {
          var index, record;
          $('#pro_user_school_id-selectized').attr(
            'placeholder',
            'Choisissez un établissement scolaire...'
          );
          $selectize.clear();
          $selectize.clearOptions();
          for (index in res) {
            record = res[index];
            console.log(record);
            $selectize.addOption({
              text: record[1],
              value: record[0],
            });
          }
          $selectize.refreshOptions(true);
          $selectize.refreshItems();
        },
      });
    },
    load: function (query, callback) {
      if (!query.length) {
        return callback();
      }
      $.ajax({
        url: '/cities.json',
        type: 'GET',
        data: {
          q: query,
        },
        error: function () {
          callback();
        },
        success: function (res) {
          callback(res);
        },
      });
    },
  });

  $('#structure_birthdate.date').datepicker({
    startDate: '01/01/1959',
    endDate: '12/01/2050',
    startView: 2,
    todayBtn: 'linked',
    clearBtn: true,
    language: 'fr',
    autoclose: true,
  });

  $('.datepicker').datepicker();

  $('input:submit').attr('data-disable-with', 'Traitement en cours...');

  $('.js-select-filter').on('change', function () {
    return $(this).parents('form').submit();
  });
});
